import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Typography from '../../atoms/typography';

const Text = styled(Typography)`
  line-height: 1.5;
  margin-bottom: 1rem;

  &:last-of-type {
    margin-bottom: 3rem;
  }

  b {
    font-weight: bold;
  }
`;

const PrivacyWrapper = styled.section`
  color: ${({ theme }) => theme.color.brand};
  margin-bottom: -2rem;

  &.bb {
    border-bottom: 1px solid ${({ theme }) => theme.color.brand};
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoint.small}) {    
    margin-bottom: -3rem;
  }
`;

const Title = styled(Typography)`
  margin-top: 1rem;
  margin-bottom: 2rem;
  letter-spacing: 0.04em;

  b {
    font-weight: bold;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoint.small}) {
    :not(:first-of-type) {
      margin-top: 0;
    }
  }
`;

const Privacy = (props) => (
  <PrivacyWrapper className={props.hr ? 'bb' : ''}>
    {
      props?.heading
        && <Title element="h2" like="dec-1" dangerouslySetInnerHTML={{ __html: props.heading }} />
    }

    {
      props.elements
        ? props.elements.map((element) => (
          <Text
            key={`privacy-${element.id}`}
            dangerouslySetInnerHTML={{ __html: element.text }}
            element="div"
            like="paragraph-2"
          />
        )) : null
    }

  </PrivacyWrapper>
);

Privacy.propTypes = {
  heading: PropTypes.string.isRequired,
  elements: PropTypes.object.isRequired,
  hr: PropTypes.bool.isRequired
};

export default memo(Privacy);
